import { render } from "./share-pop.vue?vue&type=template&id=f87b11a4"
import script from "./share-pop.vue?vue&type=script&lang=js"
export * from "./share-pop.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__